import { Logger, LoggerTransformer } from "@identity/utils";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Consents } from "./types";
import { ConsentProviderFactory } from "./consent-provider-factory";
import {
  Action,
  CommunicationService,
  eventsRepository,
} from "../CommunicationService";
import { InstantConfigService } from "../InstantConfig";

@singleton()
export class OptInService {
  private consentProvider: Promise<Consents>;
  private _trackingAllowed = false;

  get trackingAllowed(): boolean {
    return this._trackingAllowed;
  }

  set trackingAllowed(value: boolean) {
    this._trackingAllowed = value;
  }

  constructor(
    @inject(CommunicationService)
    private communicationService: CommunicationService,
    @inject(ConsentProviderFactory)
    private consentProviderFactory: ConsentProviderFactory,
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(InstantConfigService)
    private instantConfigService: InstantConfigService
  ) {}

  init() {
    const icFandom1TEnabled = this.instantConfigService.get(
      "icFandom1TEnabled",
      false
    );
    this.consentProvider = this.consentProviderFactory.get(icFandom1TEnabled);
    this.consentProvider?.then((consents: Consents) => {
      this.logger.info("Sending consents: ", consents);
      this.sendConsentsToAdEngine(consents);
    });
  }

  private sendConsentsToAdEngine(consents: Consents): void {
    this.communicationService.emit(
      new Action(eventsRepository.CONSENT_READY, consents)
    );
  }
}
